<select name="input_value" class="form-dropdown form-select" [(ngModel)]="value" #input_value (change)="update()">
  <option [ngValue]="'0'" title="Select">Select</option>
  <option *ngFor="let option of values" [ngValue]="option">{{ option }}</option>
</select>
